// Плашка «Нет связи» поверх любого экрана (макет «Ошибки, отказы и пустые экраны»). Экран под
// ней остаётся: всё сделанное сохранилось, а когда связь вернётся, ожидание продолжится само.
import { useQueryClient } from "@tanstack/react-query";
import { useConnectionLost } from "../app/connection";
import styles from "./ConnectionBanner.module.css";
import { Icon } from "./icons";

export function ConnectionBanner() {
  const lost = useConnectionLost();
  const queryClient = useQueryClient();
  if (!lost) return null;
  return (
    <div className={styles.banner} role="alert">
      <Icon name="offline" size={18} />
      <span>Нет связи. Ждём интернет — всё сделанное сохранилось.</span>
      <button type="button" className={styles.retry} onClick={() => void queryClient.refetchQueries({ type: "active" })}>
        Повторить
      </button>
    </div>
  );
}
